import React from 'react';
export function FinalCTA({
  id
}: {
  id?: string;
}) {
  return <section id={id} className="w-full py-16 md:py-24 px-4 bg-muted/30" data-id="element-43">
      <div className="container max-w-4xl mx-auto text-center" data-id="element-44">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight" data-id="element-45">
          Install a Governed AI System for Marketing Execution
        </h2>

        <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-46">
          Stop stitching tools together. Stop generating content without
          attribution. Stop revising without performance visibility.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center w-full sm:w-auto" data-id="element-47">
          <a href="#" className="inline-flex items-center justify-center rounded-lg px-8 py-3 text-base font-semibold text-white bg-[hsl(var(--brand-gold))] hover:bg-[hsl(44,100%,42%)] transition-colors w-full sm:w-auto" aria-label="Book a Demo" data-id="element-48">
            Book a Demo
          </a>
          <a href="#" className="inline-flex items-center justify-center rounded-lg px-8 py-3 text-base font-semibold text-foreground bg-transparent border-2 border-border hover:bg-muted transition-colors w-full sm:w-auto" aria-label="See the System in Action" data-id="element-49">
            See the System in Action
          </a>
        </div>
      </div>
    </section>;
}